import { createFileRoute } from '@tanstack/react-router';
import { UsersPage } from '../../features/users/UsersPage.jsx';

export const Route = createFileRoute('/_app/users/')({ component: UsersPage });
